import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function EntityPerformanceRates({ metrics }) {
    const rates = [
        { label: "By Followers", value: metrics["Eng. Rate by Followers"] || metrics["Eng. Rate by Subscribers"] },
        { label: "By Reach", value: metrics["Eng. Rate by Reach"] },
        { label: "By Views", value: metrics["Eng. Rate by Views"] }
    ];

    return (
        <MDBox>
            <MDTypography variant="button" fontWeight="bold" color="text" display="block" mb={1}>
                Performance Rates
            </MDTypography>
            <Grid container spacing={1}>
                {rates.map((rate, idx) => (
                    <Grid item xs={4} key={idx}>
                        <MDBox
                            sx={{
                                border: "1px solid #e0e0e0",
                                borderRadius: 2,
                                p: 1,
                                textAlign: "center",
                                backgroundColor: "white"
                            }}
                        >
                            <MDTypography variant="h6" color="success">
                                {rate.value ? `${Number(rate.value).toFixed(2)}%` : "0%"}
                            </MDTypography>
                            <MDTypography variant="caption" color="text" sx={{ display: "block", lineHeight: 1.2, mt: 0.5 }}>
                                {rate.label}
                            </MDTypography>
                        </MDBox>
                    </Grid>
                ))}
            </Grid>
        </MDBox>
    );
}

EntityPerformanceRates.propTypes = {
    metrics: PropTypes.object.isRequired,
};

export default EntityPerformanceRates;
